import React from "react";
import { Link } from "react-router-dom";
import "./Hiddensidebar.css";

export default function Sidebar({ isOpen, setIsOpen }) {
  return (
    <>
      {/* HAMBURGUESA */}
      <button 
        className={`sidebar-toggle ${isOpen ? "inside" : "outside"}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        ☰
      </button>
       {/* 🔥 TÍTULO MENÚ */}
      <span className={`sidebar-title ${isOpen ? "inside" : "outside"}`}>
        Menú
      </span>

      <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>
        <ul>
          <li><Link onClick={() => setIsOpen(false)} to="/inicio">Inicio</Link></li>
          {/*<li><Link onClick={() => setIsOpen(false)} to="/prestamos">Préstamos</Link></li>*/}
          <li><Link onClick={() => setIsOpen(false)} to="/clientes">Clientes</Link></li>
          {/*<li><Link onClick={() => setIsOpen(false)} to="/pagos">Pagos</Link></li>*/}
          {/*<li><Link onClick={() => setIsOpen(false)} to="/recuperaciones">Recuperaciones</Link></li>*/}
          {/*<li><Link onClick={() => setIsOpen(false)} to="/reportes">Reportes</Link></li>*/}
          {/*<li><Link onClick={() => setIsOpen(false)} to="/configuracion">Configuración</Link></li>*/}
        </ul>
      </aside>
    </>
  );
}